// eslint-disable-next-line import/no-cycle
import {
  addApiKey,
  deleteApiKey,
  loadApiKeys,
} from '@/services/repository';
import * as types from '@/store/apiKeys/actionTypes';
import {
  CLEAR_API_KEYS,
  CLEAR_CREATED_API_KEY,
  SET_API_KEYS,
  SET_CREATED_API_KEY,
} from '@/store/apiKeys/mutationTypes';

export default {
  async [types.LOAD_API_KEYS]({commit}) {
    try {
      const activities = await loadApiKeys();
      commit(SET_API_KEYS, activities);
    } catch (e) {
      commit(CLEAR_API_KEYS);
    }
  },
  async [types.DELETE_API_KEY]({ dispatch }, payload) {
    await deleteApiKey(payload);
    await dispatch(types.LOAD_API_KEYS);
  },
  async [types.ADD_API_KEY]({dispatch, commit}, payload) {
    try {
      const createdApiKey = await addApiKey(payload);
      commit(SET_CREATED_API_KEY, createdApiKey);
      await dispatch(types.LOAD_API_KEYS);
    } catch (e) {
      commit(CLEAR_CREATED_API_KEY);
      throw e;
    }
  },
  async [types.CLEAR_CREATED_API_KEY]({ commit }) {
    commit(CLEAR_CREATED_API_KEY);
  },
};
